import {API_TYPES, WIDGET_TYPES, WIDGETS_PARAMS_RESOURCE} from "../../consts";
import {ENTITY_TYPES,} from "../../app/consts";
import {ODDS_TYPES} from "../../components/odds/components/odds-consts";
import {singleton} from "../../../infrastructure/decorators/singleton";

@singleton
export class BootstrapSettings {

  static injectables = [];

  apiType: API_TYPES;
  widgetType: WIDGET_TYPES;
  entityType: ENTITY_TYPES = null;
  entityId: String;
  oddsType: ODDS_TYPES;
  showOdds: Boolean;
  eventClick: Function;
  lang: String;
  adsProvider: String;
  scoresContainerId: String;
  buttonVisible: Boolean = false;
  buttonClickEvent: Function;
  enableCompetitionSelection: Boolean = false;
  supportTopGames: Boolean = false;
  userCountryId: Number = null;
  partner: String = 'default';
  scoresFilter: String;
  calculatorFilter: String;
  gameLinkFunction: Function;
  applicationStartTime: Number;
  alwaysShowAllActiveCompetitions: Boolean;
  useClientUserCountryId: Boolean = false;
  publisherId: String = null;
  allScoresUrl: String = null;
  sponsoredBookmakerUrl: String = null;
  limitHeightDisplay: String = null;
  allowPremiumData: Boolean = false;
  showSponsorship: Boolean = false;
  showPoweredBy: Boolean = false;
  blockInnerLinks: Boolean = false;
  allowInsight: Boolean = false;
  enableImpressionCount: Boolean = false;
  liveMode: Boolean = false;
  useScrollingButtons: Boolean = false;
  hideCompetitionTitle: Boolean = false;
  hideHomeAwayTabs: Boolean = false;
  numberOfGames: Number;
  showScoresNavigation: Boolean = true;
  paramsResource: WIDGETS_PARAMS_RESOURCE = WIDGETS_PARAMS_RESOURCE.config;
  entitiesRecognizerUrl: String = '';
  innerLinks: String = '';
  showDisclaimer: Boolean = false;
  seeMoreDisplay: Boolean = false;
  numberOfOutrights: Number = null;
  specificStats: Boolean = false;
  showEntityHeader: Boolean = false;
  hidePoweredBy: Boolean = false;
  specificStatsCount: Number;
  trendsLayout: String;
  displayOption: String;
  isPreview: Boolean;
  overridePoweredBy: Boolean;
  poweredByLinkedText: String;
  theme: String;
  widgetId: String;
  marketTypes: String;

  constructor(params: BootstrapSettings) {
    Object.assign(this, params);

    console.log(params)

    const isWidget: Boolean = params.widgetType && params.widgetType !== WIDGET_TYPES.website;
    this.eventClick = params.eventClick || window.integrationLinkClick;
    this.allowPremiumData = typeof params.allowPremiumData === "boolean" ? params.allowPremiumData : params.allowPremiumData === "true";
    this.showOdds = typeof params.showOdds === "boolean" ? params.showOdds : params.showOdds === 'true';
    this.supportTopGames = typeof params.supportTopGames === "boolean" ? params.supportTopGames : params.supportTopGames === 'true';
    this.useClientUserCountryId = typeof params.useClientUserCountryId === "boolean" ? params.useClientUserCountryId : params.useClientUserCountryId === "true";
    this.publisherId = params.publisherId ? Number(params.publisherId) : null;
    this.numberOfGames = typeof params.numberOfGames === "string" ? Number(params.numberOfGames) : params.numberOfGames;
    this.alwaysShowAllActiveCompetitions = typeof params.alwaysShowAllActiveCompetitions === "boolean" ? params.alwaysShowAllActiveCompetitions : params.alwaysShowAllActiveCompetitions === "true";
    this.showScoresNavigation = typeof params.showScoresNavigation === "boolean" ? params.showScoresNavigation : params.showScoresNavigation === "true";
    this.scoresFilter = params.scoresFilter === 'recent' ? '' : params.scoresFilter;
    this.calculatorFilter = params.calculatorFilter === undefined ? null : params.calculatorFilter;
    this.showSponsorship = typeof params.showSponsorship === "boolean" ? params.showSponsorship : params.showSponsorship === "true";
    this.showPoweredBy = false;
    this.blockInnerLinks = isWidget ? (!params.innerLinks || params.innerLinks === "block" || params.innerLinks === "default") : false;
    this.allowInsight = typeof params.allowInsight === "boolean" ? params.allowInsight : params.allowInsight === "true";
    this.enableImpressionCount = typeof params.enableImpressionCount === "boolean" ? params.enableImpressionCount : params.enableImpressionCount === "true";
    this.applicationStartTime = params.applicationStartTime || window.applicationStartTime;
    this.liveMode = typeof params.liveMode === "boolean" ? params.liveMode : params.liveMode === "true";
    this.useScrollingButtons = typeof params.useScrollingButtons === "boolean" ? params.useScrollingButtons : params.useScrollingButtons === "true";
    this.hideCompetitionTitle = typeof params.hideCompetitionTitle === "boolean" ? params.hideCompetitionTitle : params.hideCompetitionTitle === "true";
    this.hideHomeAwayTabs = typeof params.hideHomeAwayTabs === "boolean" ? params.hideHomeAwayTabs : params.hideHomeAwayTabs === "true";
    this.paramsResource = WIDGETS_PARAMS_RESOURCE.config;
    this.paramsResource = params.paramsResource || WIDGETS_PARAMS_RESOURCE.config;
    this.use365Prefix = params.innerLinks === "scores365";
    this.showDisclaimer = typeof params.showDisclaimer === "boolean" ? params.showDisclaimer : params.showDisclaimer === "true";
    this.specificStatsCount = params.specificStatsCount ? Number(params.specificStatsCount) : null;
    this.showEntityHeader = typeof params.showEntityHeader === "boolean" ? params.showEntityHeader : params.showEntityHeader === "true";
    this.showSpecificStats = typeof params.specificStats === "boolean" ? params.specificStats : params.specificStats === "true";
    this.trendsLayout = params.trendsLayout;
    this.isPreview = params.displayOption === "preview";
    this.seeMoreDisplay = typeof params.seeMoreDisplay === "boolean" ? params.seeMoreDisplay : params.seeMoreDisplay === "true";
    this.numberOfOutrights = typeof params.numberOfOutrights === "string" ? Number(params.numberOfOutrights) : params.numberOfOutrights;
    this.hidePoweredBy = typeof params.hidePoweredBy === "boolean" ? params.hidePoweredBy : params.hidePoweredBy === "true";
    this.overridePoweredBy = params.overridePoweredBy === true && params.poweredByLinkedText.length > 0;
    this.limitHeightDisplay = Number.parseInt(params.limitHeightDisplay);
    this.theme = params.theme;
    this.widgetId = params.widgetId || Math.random().toString(36);
    this.standingsOnlyMajorColumns = typeof params.standingsOnlyMajorColumns === "boolean" ? params.standingsOnlyMajorColumns : params.standingsOnlyMajorColumns === 'true';
    if(this.standingsOnlyMajorColumns){
      this.hideHomeAwayTabs = true;
    }

    this.betBoostLayout = params.betBoostLayout || 'slider';
    this.betBoostOrderBy = params.betBoostOrderBy || 'percentage';

    this.marketTypes = params.marketTypes;
  }
}
